import { getCookie } from "@/lib/client/cookies";

export const COOKIE_CONSENT_CHANGED_EVENT = "cookie-consent-changed";

const REFERRAL_EVENT_NAME = "referral_visit";
const SENT_REFERRAL_SESSION_KEY = "kurb_ga_referral_code";

export const sendReferralToGtag = (referralCode = getCookie("referral_code")) => {
  if (
    typeof window === "undefined" ||
    !referralCode ||
    getCookie("cookieConsent") !== "true" ||
    !window.gtag
  ) {
    return;
  }

  try {
    window.gtag("set", "user_properties", {
      referrer_code: referralCode,
    });

    if (window.sessionStorage.getItem(SENT_REFERRAL_SESSION_KEY) === referralCode) {
      return;
    }

    window.gtag("event", REFERRAL_EVENT_NAME, {
      event_category: "acquisition",
      referrer_code: referralCode,
    });
    window.sessionStorage.setItem(SENT_REFERRAL_SESSION_KEY, referralCode);
  } catch (error) {
    console.error("Failed to send referral code to Google Analytics:", error);
  }
};
